import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SchemaProvider } from "@/contexts/SchemaContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Simulations from "@/pages/admin/Simulations";
import AdminHeadsets from "@/pages/admin/AdminHeadsets";
import Users from "@/pages/admin/Users";
import TelemetryAdmin from "@/pages/admin/TelemetryAdmin";
import DeviceApi from "@/pages/admin/DeviceApi";
import Structure from "@/pages/admin/Structure";
import ModuleGuide from "@/pages/ModuleGuide";
import PatientDetail from "@/pages/PatientDetail";
import TherapiesPage from "@/pages/clinician/TherapiesPage";
import Roster from "@/pages/clinician/Roster";
import MyHeadsets from "@/pages/clinician/MyHeadsets";
import HeadsetDetail from "@/pages/HeadsetDetail";
import { Toaster } from "sonner";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin/simulations" : "/roster"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <SchemaProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              {/* Admin */}
              <Route path="/admin/simulations" element={<ProtectedRoute roles={["admin"]}><Simulations /></ProtectedRoute>} />
              <Route path="/admin/headsets" element={<ProtectedRoute roles={["admin"]}><AdminHeadsets /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
              <Route path="/admin/telemetry" element={<ProtectedRoute roles={["admin"]}><TelemetryAdmin /></ProtectedRoute>} />
              <Route path="/admin/structure" element={<ProtectedRoute roles={["admin"]}><Structure /></ProtectedRoute>} />
              <Route path="/admin/device-api" element={<ProtectedRoute roles={["admin"]}><DeviceApi /></ProtectedRoute>} />

              {/* Clinician */}
              <Route path="/roster" element={<ProtectedRoute roles={["therapist", "admin"]}><Roster /></ProtectedRoute>} />
              <Route path="/headsets" element={<ProtectedRoute roles={["therapist", "admin"]}><MyHeadsets /></ProtectedRoute>} />
              <Route path="/telemetry" element={<ProtectedRoute roles={["therapist", "admin"]}><TelemetryAdmin /></ProtectedRoute>} />

              <Route path="/therapies" element={<ProtectedRoute roles={["therapist", "admin"]}><TherapiesPage /></ProtectedRoute>} />

              <Route path="/modules" element={<ProtectedRoute roles={["therapist", "admin"]}><ModuleGuide /></ProtectedRoute>} />

              {/* Shared */}
              <Route path="/patients/:id" element={<ProtectedRoute roles={["therapist", "admin"]}><PatientDetail /></ProtectedRoute>} />
              <Route path="/headsets/:id" element={<HeadsetDetail />} />
            </Route>

            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
        </SchemaProvider>
      </ConfirmProvider>
    </AuthProvider>
  );
}
